import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useFetchMisEvaluados = ({ id, Ad, evaluadorWeb }) => {
  const [response, setResponse] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url = `/desempeno_detalle/${id}/?a=${Ad ? 'True' : 'False'}`
        if (evaluadorWeb) {
          url += `&evaluador_web=${evaluadorWeb}`
        }
        const result = await axios.get(url)
        setResponse(result.data)
      } catch (error) {
        setError(error.response?.data || error.message || 'Error al cargar los datos')
      } finally {
        setLoading(false)
      }
    }
    if (id) {
      fetchData()
    }
    if (Ad) {
      fetchData()
    }
  }, [id, Ad, evaluadorWeb])

  return { response, loading, error }
}

export default useFetchMisEvaluados
